import type { FeedView } from '../lib/feed';

/** Always-visible indicator: this build places no orders (signals are alerts only). */
export function ViewOnlyBadge() {
  return (
    <span className="badge badge--paper" role="status" aria-label="View only: market data, news and signal alerts; no trading">
      <span aria-hidden="true">◉</span> VIEW ONLY
    </span>
  );
}

const TONE_CLASS: Record<FeedView['tone'], string> = {
  live: 'badge--live',
  replay: 'badge--replay',
  delayed: 'badge--delayed',
  stale: 'badge--stale',
  disconnected: 'badge--disconnected',
  fallback: 'badge--fallback',
  neutral: 'badge--neutral',
};

export function FeedBadge({ view }: { view: FeedView }) {
  return (
    <span className={`badge ${TONE_CLASS[view.tone]}`} data-testid="feed-badge" title={view.title}>
      <span className="badge__dot" aria-hidden="true" />
      {view.label}
    </span>
  );
}

export function MarketBadge({ open }: { open: boolean | null }) {
  if (open === null) return null;
  return (
    <span className={`badge ${open ? 'badge--gold' : 'badge--neutral'}`}>
      <span aria-hidden="true">{open ? '◷' : '☾'}</span> {open ? 'Market open' : 'Market closed'}
    </span>
  );
}
